module.exports = fox._r("images/faq-back-arr.png", __webpack_public_path__ + "_/_/_/common/faq/images/faq-back-arr.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/faq/images/faq-back-arr.png
// module id = 484
// module chunks = 2